module.exports = __webpack_public_path__ + "static/media/K-Clubs.82ffdfe8.svg";